import objectFitImages from 'object-fit-images';
import { init as mediaInit } from './modules/media';
import { init as formsInit } from './modules/forms';
import { init as animation } from './modules/animations';
import { init as modal } from './modules/modal';
import { init as textSizeIncrease } from './modules/text-size-increase';
import { init as navigationHeader } from './modules/navHeader';
import { init as carousels } from './modules/carousel';
import { init as imageHelpers } from './modules/images';
import { init as bannerMarketing } from './modules/banner-marketing';
import { init as filters } from './modules/filters';
import { init as iconInit } from './modules/animatedIcons';
import { init as iconImageGenerator } from './modules/image-generator';
import { init as socials } from './modules/socials';
import { init as quickLinks } from './modules/quick-links';
import { init as autocomplete } from './modules/autocomplete';
import { init as newsletterSignup } from './modules/newsletter-signup';
import { init as gravityForms } from './modules/gravity-forms';
import { init as formAssembly } from './modules/form-assembly';
import { init as confirmationContent } from './modules/form-confirmation';
import { init as nswReferralForm } from './modules/nsw-referral-form';
import { init as nswTherapyDogsFrom } from './modules/nsw-therapy-dogs-form';
import QasAddress from './modules/address-qas';
import { init as scrollTo } from './modules/scroll-to';
import { init as pieChartInit } from './modules/pie-chart';
import { init as carouselNav } from './modules/carousel-nav';
import { init as statCounterInit } from './modules/stat-counter';
import { init as randomBackgroundColour } from './modules/random-background-colour';
import { init as enterViewTracking } from './modules/enter-view-tracking';
import { init as audioPlayer } from './modules/audio-player';
import { init as notification } from './modules/notification';
import { init as tabbedNav } from './modules/tabbed-nav';
import { init as salesforceForm } from './modules/salesforce-form';
import { init as trackingInit } from './modules/ga4-tracking';
import { init as wpcf7Loader } from './modules/cf7-loader';
import { init as wpcf7Debounce } from './modules/cf7-submit-debounce';
import { init as transparentVideo } from './modules/transparent-video';
import { init as facebookInit } from './modules/facebook';
import { init as turnstileInit } from './modules/turnstile';
import { init as fileDownloadInit } from './modules/file-download';

import './modules/tooltips';
import './modules/lax';

// Load any Alpine JS scripts first, followed by the alpinejs library.
import './alpine/news-detail';
import './alpine/form-stepper';
import './alpine/pop-up';
import './alpine/video-pop-up';
import './alpine/donations-appeal';
import './alpine/donations-banner';
import './alpine/donations-nsw';
import './alpine/donations-sa';
import './alpine/donations-sa-min';
import './alpine/puppy-pals-login-qld';
import './alpine/donations-vic';
import './alpine/icon-set';
import './alpine/audio-toggle'; // TODO: Thinking this is the best place to includes these scripts since there's multiple modules that will use it.
import Alpine from 'alpinejs';


class App {
  constructor() {
    App.loaded = false;
    App.addEventListeners();
    App.focusOutline();
  }

  static addEventListeners() {
    document.addEventListener('DOMContentLoaded', App.init);
  }

  static focusOutline() {
    const noKeyboardClass = 'no-keyboard-navigation-in-use';

    // Add default class to html
    document.documentElement.classList.add(noKeyboardClass);

    // On keyboard use, remove class
    window.addEventListener('keydown', () => {
      document.documentElement.classList.remove(noKeyboardClass);
    });

    //  On click, add class
    window.addEventListener('click', () => {
      document.documentElement.classList.add(noKeyboardClass);
    });
  }

  // Add any callbacks that need to run when content added to the page
  static init() {
    if (App.loaded) {
      return;
    }
    App.loaded = true;

    // Initiate first so other files can access instance
    trackingInit();
    facebookInit();
    newsletterSignup();
    objectFitImages();
    mediaInit();
    formsInit();
    animation();
    textSizeIncrease();
    modal();
    navigationHeader();
    carousels();
    imageHelpers();
    bannerMarketing();
    filters();
    iconInit();
    iconImageGenerator();
    socials();
    quickLinks();
    scrollTo();
    autocomplete();
    QasAddress();
    gravityForms();
    formAssembly();
    confirmationContent();
    nswReferralForm();
    nswTherapyDogsFrom();
    pieChartInit();
    carouselNav();
    statCounterInit();
    randomBackgroundColour();
    enterViewTracking();
    audioPlayer();
    notification();
    tabbedNav();
    salesforceForm();
    wpcf7Loader();
    wpcf7Debounce();
    transparentVideo();
    turnstileInit();
    fileDownloadInit();

    window.Alpine = Alpine

    Alpine.start()
  }
}

new App();
